<template>
  <div>
    <div class="titre-h3 mt-3 mb-3 ml-1">
      Mon compte
    </div>
    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <ParametresExploitation />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <InfoAdherent
          :tous-conseillers="tousConseillers"
          class="eq-height"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import InfoAdherent from './components/info-adherent.vue'
import ParametresExploitation from './components/parametres-exploitation.vue'

export default {
  name: 'Compte',
  components: { InfoAdherent, ParametresExploitation },
  data () {
    return {
      loading: false,
      serverError: false
    }
  },
  computed: {
    ...mapGetters({
      adherent: 'adherent/adherent',
      abonnements: 'adherent/abonnements',
      tousConseillers: 'adherent/tousConseillers',
    }),
  },

  created () {
    if (this.$cookies.get('NUMTIERS_SELECTED')) {
      this.fetchAdherent(this.$cookies.get('NUMTIERS_SELECTED'))
        .then(() => {
          this.initialize()
        })
    } else {
      this.initialize()
    }
  },

  methods: {
    ...mapActions({
      fetchAdherent: 'adherent/fetchAdherent',
      getTousConseillers: 'adherent/getTousConseillers',
    }),

    initialize () {
      Promise.all([
        this.getTousConseillers()
      ])
      .catch(() => {
        this.serverError = true
      })
      .finally(() => {
        this.loading = false
      })
    },
  }
}
</script>
